// src/components/Layout.jsx
import React, { useState } from "react";
import Sidebar from "./Sidebar";

export default function Layout({ children, panelMinimized, setPanelMinimized }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="d-flex">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        // quando clicar em "Uploads" na sidebar, abre o painel global
        openUploadPanel={() => setPanelMinimized(false)}
      />

      <div
        className="flex-grow-1"
        style={{
          marginLeft: collapsed ? 70 : 230,
          padding: 20,
          width: "100%",
          minHeight: "100vh",
          boxSizing: "border-box",
        }}
      >
        {children}
      </div>
    </div>
  );
}
